// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pj-form-container {
  width: 100%;
  background: #e8e9ea;
}

.pj-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  background: #00468c;
  color: #fff;
}

.pj-form-title {
  margin: 1.5%;
  color: #fff;
}

.pj-close-btn {
  font-size: xx-large;
}

.pj-step-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 2% 0;
  padding: 0 5%;
}

.pj-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
}

/* Step Circle */
.pj-step-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  z-index: 1;
  margin-bottom: 2%;
}

/* Active step (current step) */
.pj-step-circle.active {
  background: #00468c; /* Blue */
}

/* Completed step */
.pj-step-circle.completed {
  background: #7ac127;
}

/* Gray background line */
.pj-step-bg {
  position: absolute;
  top: 18%;
  left: var(--step-line-left);
  width: var(--step-line-total-width);
  height: 4px;
  background: lightgray;
  z-index: 0;
}

/* Green progress line */
.pj-step-line {
  position: absolute;
  top: 18%;
  left: var(--step-line-left);
  width: var(--step-progress-width);
  height: 4px;
  background: #7ac127;
  z-index: 1;
  transition: width 0.3s ease-in-out;
}

.pj-step-label {
  margin-top: 5%;
  font-size: small;
  font-weight: bold;
  color: rgb(198, 197, 197);
}

.pj-step-item.active .pj-step-label {
  color: black;
}

.pj-step-item.completed .pj-step-label {
  color: black;
}

.pj-form-grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, minmax(20%, 1fr));
  gap: 2%;
  padding: 1%;
}

.pj-form-group {
  margin-bottom: 4%;
}

.pj-form-group label {
  font-size: small;
  font-weight: bold;
  padding: 0%;
  margin: 0 0 0 10%;
}

/* Form Inputs */
.pj-form-grid input {
  margin: 0 0 0 10%;
  padding: 2%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 76%;
  background-color: #ffffff;
}

.pj-form-grid select {
  margin: 0 0 0 10%;
  padding: 2%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 81%;
  background-color: #ffffff;
}

.pj-form-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2%;
  margin: 0 3.2%;
}

.pj-description {
  flex: 1 1;
}
.pj-description label {
  font-size: small;
  font-weight: bold;
}

.pj-description textarea {
  width: 95%;
  height: 60px;
  resize: none;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
}

.pj-attachment {
  flex: 1 1; /* Attachment section smaller */
  display: flex;
  flex-direction: column;
}

.pj-attachment label {
  font-size: small;
  font-weight: bold;
}

.pj-attachment-wrapper {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 75px;
  width: 100%;
}

.pj-file-links {
  width: 80%;
  text-decoration: none;
  overflow-x: auto;
  overflow-y: auto;
}

.pj-file-name {
  color: #00468c;
  font-size: medium;
}

.pj-attachment-upload {
  display: flex;
  align-items: center;
}

.pj-hidden-file-input {
  display: none;
}

.pj-custom-file-upload {
  background: #79c42b;
  color: #fff;
  padding: 6px 15px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  display: inline-block;
}

.pj-form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 5%;
  margin: 1% 5%;
}

.pj-next-btn {
  background: #79c42b;
  color: white;
  padding: 1% 5%;
  border: 1px solid #79c42b;
  cursor: pointer;
  border-radius: 5px;
  font-size: small;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.pj-next-btn:hover {
  background: #68a822; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.pj-next-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.pj-next-btn:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.pj-cancel-btn {
  color: #000;
  padding: 1% 5%;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #79c42b;
  background-color: #fff;
  font-size: small;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.pj-cancel-btn:hover {
  background-color: #f2f2f2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.pj-cancel-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.pj-cancel-btn:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.step-two-grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(2, minmax(20%, 1fr));
  gap: 2%;
  padding: 0 2%;
}

.pj-form-group2 {
  margin-bottom: 5%;
}

.pj-form-group2 label {
  width: 90%;
  display: flex;
  justify-content: space-between;
  font-size: small;
  font-weight: bold;
  padding: 0%;
  margin: 0 0 0 5%;
}

/* Form Inputs */
.step-two-grid input {
  margin: 0 0 0 5%;
  padding: 2%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 85%;
  background-color: #ffffff;
}

.step-two-grid select {
  margin: 0 0 0 5%;
  padding: 2%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 90%;
  background-color: #ffffff;
}

.pj-input {
  height: 100px;
}

.employee-list-box {
  display: grid;
  grid-template-columns: repeat(3, minmax(20%, 1fr));
  width: 85%;
  border: 1px solid #ccc;
  padding: 2%;
  height: 100px;
  overflow-y: auto;
  background: #fff;
  margin-left: 5%;
  margin-top: 2%;
  border-radius: 5px;
}

.selected-employee {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: small;
  background: #f3f3f3;
  padding: 2%;
  border-radius: 5px;
  margin: 2% 5%;
}

.remove-employee {
  cursor: pointer;
  color: red;
  margin-left: 10px;
  font-weight: bold;
}

.placeholder-text {
  display: flex;
  width: 90%;
  color: #888;
  font-style: italic;
}

.key-input {
  margin: 0 4.5%;
}

.key-point {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.key-point input {
  border: none;
  outline: none;
  flex: 1 1;
  font-size: 16px;
}

.key-input label {
  font-size: small;
  font-weight: bold;
}

.key-considerations-box {
  width: 99%;
  height: 100px;
  padding: 1% 0 0 1%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  background-color: #fff;
  overflow-y: auto;
}

.pj-step-three {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.milestone-table-container {
  width: 98%;
  max-height: 300px;
  overflow-y: auto;
}

.milestone-table {
  width: 100%;
  border-collapse: collapse;
}

.milestone-table thead th {
  position: sticky;
  top: 0;
  background-color: #e8e9ea;
  z-index: 10;
  font-weight: bold;
  font-size: 12px;
  padding: 1%;
}

.milestone-table td {
  padding: 10px;
  text-align: center;
}

.milestone-table th:nth-child(1) {
  min-width: 60px;
  text-align: center;
}

.milestone-table input {
  width: 80%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

.milestone-table select {
  width: 80%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: left;
  background-color: #f7f7f7;
  color: #333;
}

/* Style options based on their value */
select option[value="Active"] {
  background-color: #d1ecf1;
}

select option[value="Pending"] {
  background-color: #fff3cd;
}

select option[value="Completed"] {
  background-color: #d4edda;
}

.add-milestone-btn {
  margin: 2%;
  margin-left: 80%;
  background-color: #79c42b;
  color: white;
  border: none;
  padding: 1% 2%;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
}

.add-milestone-btn:hover {
  background-color: #79c42b;
}

.pj-step-four {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.project-finance-main {
  width: 100%;
}

.project-finance {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0 6%;
}

.project-finance-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 15%;
}

.project-finance-group label {
  font-weight: bold;
  font-size: small;
}

.project-finance-group input {
  width: 80%;
  padding: 5px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.main-finance {
  width: 100%;
}

.payout-details {
  width: 100%;
  display: flex;
  text-align: left;
  padding-left: 1%;
  font-size: medium;
}

.finance-table-container {
  width: 98%;
  max-height: 280px;
  overflow-y: auto;
  padding: 0 0 0 1%;
}

.finance-table {
  width: 100%;
  border-collapse: collapse;
}

.finance-table th {
  position: sticky;
  top: 0;
  background-color: #e8e9ea;
  z-index: 10;
  font-weight: bold;
  font-size: 12px;
  padding: 1%;
  font-weight: bold;
}

.finance-table td {
  padding: 0.5%;
  text-align: center;
  font-size: 12px;
  align-items: center;
}

.finance-table th:nth-child(1) {
  min-width: 43px;
  text-align: center;
}

.finance-table input {
  width: 80%;
  padding: 3%;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

.finance-table select {
  padding: 5%;
  border-radius: 4px;
  text-align: center;
}

.completed-date {
  display: flex;
  width: 90px;
  font-size: small;
  color: #000;
  padding: 8%;
  background-color: #d4edda;
  border-radius: 40px;
}

.finance-table tfoot .summary-row {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  font-weight: bold;
  padding: 10px;
  border: 1px solid #ccc;
  z-index: 10;
}

.finance-table tfoot .summary-row span {
  margin: 0 4%;
}

.step-four-group {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 150px;
}

.step-four-group input {
  background-color: #ccc;
  padding: 1%;
  width: 50%;
}

.small-input input {
  background-color: #ccc;
  padding: 1%;
  width: 40px;
}

.step-four-group2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 2%;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 150px;
}

.step-four-group2 input {
  background-color: #ccc;
  padding: 1%;
  width: 50%;
}

.step-four-group2 span {
  font-size: medium;
}

.small-input2 input {
  background-color: #ccc;
  padding: 1%;
  width: 50px;
  margin-top: 1%;
}

input[type="checkbox"] {
  appearance: none; /* Remove default styling */
  width: 15px;
  height: 15px;
  margin: 0;
  border: 2px solid #79c42b;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  position: relative;
}

input[type="checkbox"]:checked {
  background-color: #79c42b;
  border: 2px solid #79c42b;
}

input[type="checkbox"]::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 4px;
  border: 2px solid white;
  border-top: none;
  border-right: none;
  transform: rotate(-45deg);
  top: 1px;
  left: 1px;
  display: none;
}

input[type="checkbox"]:checked::after {
  display: block; /* Show tick when checked */
}

.custom-dropdown {
  position: relative;
  margin: 0 0 0 10%;
  padding: 1.7%;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 77%;
  background-color: #ffffff;
}

.dropdown-header {
  background: #fff;
  border-radius: 4px;
  font-size: small;
  padding: 2%;
  width: 98%;
  height: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-header:hover {
  white-space: normal; /* Allow full text to be seen on hover */
  height: auto;
  max-height: 200px; /* Prevent too much expansion */
}

.dropdown-menu {
  position: absolute;
  background: white;
  border: 1px solid #ddd;
  width: 95%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 6px;
  margin: 0;
  font-size: small;
}

.dropdown-item input {
  margin-right: 8px;
}

.project-category {
  font-size: small;
  font-weight: bold;
  padding: 0%;
  margin: 0 0 0 10%;
}

.employee-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: 120px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}

.employee-item {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  font-size: small;
}

.employee-item:hover {
  background-color: #f0f0f0;
}

.no-employees {
  padding: 8px;
  color: gray;
  text-align: center;
}

.add-employee {
  margin: 0 0 0 5%;
  padding: 0;
  border: 1px solid #cccbce;
  border-radius: 5px;
  width: 90%;
  background-color: #ffffff;
}

.pj-search-box {
  position: relative;
  display: flex;
  width: 50%;
  margin-bottom: 0.5%;
}

.pj-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 1.2em;
  margin-left: 80%;
}

.pj-download {
  font-size: x-large;
  color: #00468c;
  transition: transform 0.1s ease, color 0.1s ease;
}

.pj-download:active {
  transform: scale(0.95);
  color: #003366;
}

.pj-file-name.disabled {
  pointer-events: none;
  color: grey;
  text-decoration: none;
  cursor: default;
}

.pj-custom-file-upload.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/ProjectForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB,EAAE,SAAS;AAChC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,qBAAqB;EACrB,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO,EAAE,+BAA+B;EACxC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB;wBACsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,oBAAoB;EACzC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB;wBACsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,OAAO;EACP,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,wCAAwC;EAC7D,YAAY;EACZ,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".pj-form-container {\n  width: 100%;\n  background: #e8e9ea;\n}\n\n.pj-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 5%;\n  background: #00468c;\n  color: #fff;\n}\n\n.pj-form-title {\n  margin: 1.5%;\n  color: #fff;\n}\n\n.pj-close-btn {\n  font-size: xx-large;\n}\n\n.pj-step-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  margin: 2% 0;\n  padding: 0 5%;\n}\n\n.pj-step-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  width: 100%;\n}\n\n/* Step Circle */\n.pj-step-circle {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: lightgray;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  color: #fff;\n  z-index: 1;\n  margin-bottom: 2%;\n}\n\n/* Active step (current step) */\n.pj-step-circle.active {\n  background: #00468c; /* Blue */\n}\n\n/* Completed step */\n.pj-step-circle.completed {\n  background: #7ac127;\n}\n\n/* Gray background line */\n.pj-step-bg {\n  position: absolute;\n  top: 18%;\n  left: var(--step-line-left);\n  width: var(--step-line-total-width);\n  height: 4px;\n  background: lightgray;\n  z-index: 0;\n}\n\n/* Green progress line */\n.pj-step-line {\n  position: absolute;\n  top: 18%;\n  left: var(--step-line-left);\n  width: var(--step-progress-width);\n  height: 4px;\n  background: #7ac127;\n  z-index: 1;\n  transition: width 0.3s ease-in-out;\n}\n\n.pj-step-label {\n  margin-top: 5%;\n  font-size: small;\n  font-weight: bold;\n  color: rgb(198, 197, 197);\n}\n\n.pj-step-item.active .pj-step-label {\n  color: black;\n}\n\n.pj-step-item.completed .pj-step-label {\n  color: black;\n}\n\n.pj-form-grid {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(4, minmax(20%, 1fr));\n  gap: 2%;\n  padding: 1%;\n}\n\n.pj-form-group {\n  margin-bottom: 4%;\n}\n\n.pj-form-group label {\n  font-size: small;\n  font-weight: bold;\n  padding: 0%;\n  margin: 0 0 0 10%;\n}\n\n/* Form Inputs */\n.pj-form-grid input {\n  margin: 0 0 0 10%;\n  padding: 2%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 76%;\n  background-color: #ffffff;\n}\n\n.pj-form-grid select {\n  margin: 0 0 0 10%;\n  padding: 2%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 81%;\n  background-color: #ffffff;\n}\n\n.pj-form-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2%;\n  margin: 0 3.2%;\n}\n\n.pj-description {\n  flex: 1;\n}\n.pj-description label {\n  font-size: small;\n  font-weight: bold;\n}\n\n.pj-description textarea {\n  width: 95%;\n  height: 60px;\n  resize: none;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 8px;\n}\n\n.pj-attachment {\n  flex: 1; /* Attachment section smaller */\n  display: flex;\n  flex-direction: column;\n}\n\n.pj-attachment label {\n  font-size: small;\n  font-weight: bold;\n}\n\n.pj-attachment-wrapper {\n  display: flex;\n  justify-content: space-around;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 75px;\n  width: 100%;\n}\n\n.pj-file-links {\n  width: 80%;\n  text-decoration: none;\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n.pj-file-name {\n  color: #00468c;\n  font-size: medium;\n}\n\n.pj-attachment-upload {\n  display: flex;\n  align-items: center;\n}\n\n.pj-hidden-file-input {\n  display: none;\n}\n\n.pj-custom-file-upload {\n  background: #79c42b;\n  color: #fff;\n  padding: 6px 15px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 14px;\n  display: inline-block;\n}\n\n.pj-form-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 5%;\n  margin: 1% 5%;\n}\n\n.pj-next-btn {\n  background: #79c42b;\n  color: white;\n  padding: 1% 5%;\n  border: 1px solid #79c42b;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: small;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.pj-next-btn:hover {\n  background: #68a822; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.pj-next-btn:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.pj-next-btn:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.pj-cancel-btn {\n  color: #000;\n  padding: 1% 5%;\n  cursor: pointer;\n  border-radius: 5px;\n  border: 1px solid #79c42b;\n  background-color: #fff;\n  font-size: small;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.pj-cancel-btn:hover {\n  background-color: #f2f2f2;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.pj-cancel-btn:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.pj-cancel-btn:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.step-two-grid {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(2, minmax(20%, 1fr));\n  gap: 2%;\n  padding: 0 2%;\n}\n\n.pj-form-group2 {\n  margin-bottom: 5%;\n}\n\n.pj-form-group2 label {\n  width: 90%;\n  display: flex;\n  justify-content: space-between;\n  font-size: small;\n  font-weight: bold;\n  padding: 0%;\n  margin: 0 0 0 5%;\n}\n\n/* Form Inputs */\n.step-two-grid input {\n  margin: 0 0 0 5%;\n  padding: 2%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 85%;\n  background-color: #ffffff;\n}\n\n.step-two-grid select {\n  margin: 0 0 0 5%;\n  padding: 2%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 90%;\n  background-color: #ffffff;\n}\n\n.pj-input {\n  height: 100px;\n}\n\n.employee-list-box {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(20%, 1fr));\n  width: 85%;\n  border: 1px solid #ccc;\n  padding: 2%;\n  height: 100px;\n  overflow-y: auto;\n  background: #fff;\n  margin-left: 5%;\n  margin-top: 2%;\n  border-radius: 5px;\n}\n\n.selected-employee {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: small;\n  background: #f3f3f3;\n  padding: 2%;\n  border-radius: 5px;\n  margin: 2% 5%;\n}\n\n.remove-employee {\n  cursor: pointer;\n  color: red;\n  margin-left: 10px;\n  font-weight: bold;\n}\n\n.placeholder-text {\n  display: flex;\n  width: 90%;\n  color: #888;\n  font-style: italic;\n}\n\n.key-input {\n  margin: 0 4.5%;\n}\n\n.key-point {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.key-point input {\n  border: none;\n  outline: none;\n  flex: 1;\n  font-size: 16px;\n}\n\n.key-input label {\n  font-size: small;\n  font-weight: bold;\n}\n\n.key-considerations-box {\n  width: 99%;\n  height: 100px;\n  padding: 1% 0 0 1%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  background-color: #fff;\n  overflow-y: auto;\n}\n\n.pj-step-three {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.milestone-table-container {\n  width: 98%;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.milestone-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.milestone-table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #e8e9ea;\n  z-index: 10;\n  font-weight: bold;\n  font-size: 12px;\n  padding: 1%;\n}\n\n.milestone-table td {\n  padding: 10px;\n  text-align: center;\n}\n\n.milestone-table th:nth-child(1) {\n  min-width: 60px;\n  text-align: center;\n}\n\n.milestone-table input {\n  width: 80%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.milestone-table select {\n  width: 80%;\n  padding: 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: left;\n  background-color: #f7f7f7;\n  color: #333;\n}\n\n/* Style options based on their value */\nselect option[value=\"Active\"] {\n  background-color: #d1ecf1;\n}\n\nselect option[value=\"Pending\"] {\n  background-color: #fff3cd;\n}\n\nselect option[value=\"Completed\"] {\n  background-color: #d4edda;\n}\n\n.add-milestone-btn {\n  margin: 2%;\n  margin-left: 80%;\n  background-color: #79c42b;\n  color: white;\n  border: none;\n  padding: 1% 2%;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.add-milestone-btn:hover {\n  background-color: #79c42b;\n}\n\n.pj-step-four {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.project-finance-main {\n  width: 100%;\n}\n\n.project-finance {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  padding: 0 6%;\n}\n\n.project-finance-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 15%;\n}\n\n.project-finance-group label {\n  font-weight: bold;\n  font-size: small;\n}\n\n.project-finance-group input {\n  width: 80%;\n  padding: 5px;\n  text-align: center;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.main-finance {\n  width: 100%;\n}\n\n.payout-details {\n  width: 100%;\n  display: flex;\n  text-align: left;\n  padding-left: 1%;\n  font-size: medium;\n}\n\n.finance-table-container {\n  width: 98%;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 0 0 0 1%;\n}\n\n.finance-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.finance-table th {\n  position: sticky;\n  top: 0;\n  background-color: #e8e9ea;\n  z-index: 10;\n  font-weight: bold;\n  font-size: 12px;\n  padding: 1%;\n  font-weight: bold;\n}\n\n.finance-table td {\n  padding: 0.5%;\n  text-align: center;\n  font-size: 12px;\n  align-items: center;\n}\n\n.finance-table th:nth-child(1) {\n  min-width: 43px;\n  text-align: center;\n}\n\n.finance-table input {\n  width: 80%;\n  padding: 3%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.finance-table select {\n  padding: 5%;\n  border-radius: 4px;\n  text-align: center;\n}\n\n.completed-date {\n  display: flex;\n  width: 90px;\n  font-size: small;\n  color: #000;\n  padding: 8%;\n  background-color: #d4edda;\n  border-radius: 40px;\n}\n\n.finance-table tfoot .summary-row {\n  position: sticky;\n  bottom: 0;\n  background-color: #fff;\n  font-weight: bold;\n  padding: 10px;\n  border: 1px solid #ccc;\n  z-index: 10;\n}\n\n.finance-table tfoot .summary-row span {\n  margin: 0 4%;\n}\n\n.step-four-group {\n  display: flex;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 150px;\n}\n\n.step-four-group input {\n  background-color: #ccc;\n  padding: 1%;\n  width: 50%;\n}\n\n.small-input input {\n  background-color: #ccc;\n  padding: 1%;\n  width: 40px;\n}\n\n.step-four-group2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  padding: 2%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 150px;\n}\n\n.step-four-group2 input {\n  background-color: #ccc;\n  padding: 1%;\n  width: 50%;\n}\n\n.step-four-group2 span {\n  font-size: medium;\n}\n\n.small-input2 input {\n  background-color: #ccc;\n  padding: 1%;\n  width: 50px;\n  margin-top: 1%;\n}\n\ninput[type=\"checkbox\"] {\n  appearance: none; /* Remove default styling */\n  width: 15px;\n  height: 15px;\n  margin: 0;\n  border: 2px solid #79c42b;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n}\n\ninput[type=\"checkbox\"]:checked {\n  background-color: #79c42b;\n  border: 2px solid #79c42b;\n}\n\ninput[type=\"checkbox\"]::after {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 4px;\n  border: 2px solid white;\n  border-top: none;\n  border-right: none;\n  transform: rotate(-45deg);\n  top: 1px;\n  left: 1px;\n  display: none;\n}\n\ninput[type=\"checkbox\"]:checked::after {\n  display: block; /* Show tick when checked */\n}\n\n.custom-dropdown {\n  position: relative;\n  margin: 0 0 0 10%;\n  padding: 1.7%;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 77%;\n  background-color: #ffffff;\n}\n\n.dropdown-header {\n  background: #fff;\n  border-radius: 4px;\n  font-size: small;\n  padding: 2%;\n  width: 98%;\n  height: 10px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown-header:hover {\n  white-space: normal; /* Allow full text to be seen on hover */\n  height: auto;\n  max-height: 200px; /* Prevent too much expansion */\n}\n\n.dropdown-menu {\n  position: absolute;\n  background: white;\n  border: 1px solid #ddd;\n  width: 95%;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  padding: 6px;\n  margin: 0;\n  font-size: small;\n}\n\n.dropdown-item input {\n  margin-right: 8px;\n}\n\n.project-category {\n  font-size: small;\n  font-weight: bold;\n  padding: 0%;\n  margin: 0 0 0 10%;\n}\n\n.employee-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  height: 120px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  background-color: #fff;\n}\n\n.employee-item {\n  padding: 8px;\n  cursor: pointer;\n  border-bottom: 1px solid #ddd;\n  font-size: small;\n}\n\n.employee-item:hover {\n  background-color: #f0f0f0;\n}\n\n.no-employees {\n  padding: 8px;\n  color: gray;\n  text-align: center;\n}\n\n.add-employee {\n  margin: 0 0 0 5%;\n  padding: 0;\n  border: 1px solid #cccbce;\n  border-radius: 5px;\n  width: 90%;\n  background-color: #ffffff;\n}\n\n.pj-search-box {\n  position: relative;\n  display: flex;\n  width: 50%;\n  margin-bottom: 0.5%;\n}\n\n.pj-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #999;\n  font-size: 1.2em;\n  margin-left: 80%;\n}\n\n.pj-download {\n  font-size: x-large;\n  color: #00468c;\n  transition: transform 0.1s ease, color 0.1s ease;\n}\n\n.pj-download:active {\n  transform: scale(0.95);\n  color: #003366;\n}\n\n.pj-file-name.disabled {\n  pointer-events: none;\n  color: grey;\n  text-decoration: none;\n  cursor: default;\n}\n\n.pj-custom-file-upload.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
